/**
 * @description 文件类型识别与路径解析工具，用于图片和PDF预览
 * @author fengtianhe1
 * @date 2026-07-06
 */
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
const PDF_EXTENSIONS = ['pdf'];

export default {
  /**
   * 获取文件扩展名
   */
  getExtension(path) {
    if (!path) {
      return '';
    }
    const cleanPath = path.split('?')[0];
    return cleanPath.split('.').pop().toLowerCase();
  },

  /**
   * 判断是否为图片文件
   */
  isImageFile(path) {
    return IMAGE_EXTENSIONS.includes(this.getExtension(path));
  },

  /**
   * 判断是否为PDF文件
   */
  isPdfFile(path) {
    return PDF_EXTENSIONS.includes(this.getExtension(path));
  },

  /**
   * 提取文件下载接口所需的相对路径
   */
  getDownloadPath(path) {
    if (!path) {
      return '';
    }
    if (/^https?:\/\//i.test(path)) {
      try {
        return new URL(path).pathname;
      } catch (e) {
        return path;
      }
    }
    return path;
  },

  /**
   * 解析为浏览器可直接访问的完整URL
   */
  resolveFileUrl(path) {
    if (!path) {
      return '';
    }
    if (/^https?:\/\//i.test(path)) {
      return path;
    }
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${window.location.origin}${normalized}`;
  },
};
